import axios from 'axios';
import * as Sentry from '@sentry/vue';

export async function getIpLocation(): Promise<any> {
	const config = useRuntimeConfig();
	const baseURL = config.VUE_APP_FE;

	const axiosInstance = axios.create({
		baseURL,
		headers: {
			Accept: 'application/json',
		},
	});

	try {
		const response = await axiosInstance.get('/');
		const countryCode = response.headers['x-ip2location-country-code'];

		return countryCode;
	} catch (error) {
		console.error('Error fetching IP location:', error);
		const config = useRuntimeConfig();

		const environment = config.SENTRY_ENVIRONMENT;

		if (environment !== 'localhost') {
			Sentry.captureException(error);
		}

		return null;
	}
}
